// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"a254a41c","227":"c1dd9fae","852":"4f0fa30e"}[chunkId] + ".chunk.css";
};